var i = Object.defineProperty;
var h = (a, t, e) => t in a ? i(a, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[t] = e;
var d = (a, t, e) => (h(a, typeof t != "symbol" ? t + "" : t, e), e);
import { GenericCalloutBox as u } from "./index.es170.js";
class F extends u {
  constructor(e) {
    super({ ...e, draggable: !0 });
    // default. not controlled by props
    d(this, "renderedCalloutBox");
    // controlled via props
    d(this, "poiInfo");
    this.poiInfo = e.poiInfo;
  }
  updateStatus(e) {
    var s;
    const r = super.updateStatus(e);
    return r && ((s = this.renderedCalloutBox) == null || s.updateStyle(this.styleType, r)), r;
  }
  syncCalloutBoxConfig(e) {
    var s, n, p, o, y, c;
    const r = this.renderedCalloutBox;
    r && r.objType === "TenantsCalloutBox" && e && (e.headerContainerColor && ((s = r.headerContainer) == null || s.set({ fill: e.headerContainerColor })), e.headerContainerOpacity && ((n = r.headerContainer) == null || n.set({
      opacity: e.headerContainerOpacity / 100
    })), e.propertyAddressFontColor && ((p = r.addressTextbox) == null || p.set({ fill: e.propertyAddressFontColor })), e.propertyAddressFontOpacity && ((o = r.addressTextbox) == null || o.set({
      opacity: e.propertyAddressFontOpacity / 100
    })), e.propertyNameFontColor && ((y = r.nameTextbox) == null || y.set({ fill: e.propertyNameFontColor })), e.propertyNameFontOpacity && ((c = r.nameTextbox) == null || c.set({
      opacity: e.propertyNameFontOpacity / 100
    })));
  }
  hasSameProps(e) {
    var r;
    return ((r = this.renderedCalloutBox) == null ? void 0 : r.hasSameProps(e)) || !1;
  }
}
export {
  F as POICalloutBox
};
//# sourceMappingURL=index.es171.js.map
